import { listStyles as ootbStyles } from "@insite/content-library/Widgets/Brand/BrandGallery";
import { ButtonIcon } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { listStyles as customStyles } from "@solveindustrial/Widgets/Brand/CustomBrandGallery";
import { css } from "styled-components";

ootbStyles.titleText = {
    ...ootbStyles.titleText,
    css: css`
        ${ootbStyles.titleText?.css}
        text-align: left;
    `,
};

ootbStyles.imageContainer = {
    ...ootbStyles.imageContainer,
    css: css`
        ${ootbStyles.imageContainer?.css}
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        padding: 30px 20px 40px;
    `,
};

customStyles.titleText = {
    ...customStyles.titleText,
    css: css`
        ${customStyles.titleText?.css}
        text-align: left;
    `,
};

customStyles.imageContainer = {
    css: css`
        flex: 0 0 100%;
    `,
};

customStyles.imageItem = {
    ...customStyles.imageItem,
    css: css`
        ${customStyles.imageItem?.css}
        flex-grow: 0;
        flex-shrink: 0;
        padding: 0;
    `,
};

customStyles.contentWrapper = {
    css: css`
        border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
        padding: 24px;
        position: relative;
        min-height: 80px;
    `,
};

customStyles.carouselWrapper = {
    css: css`
        overflow: hidden;
    `,
};

customStyles.carouselContainerWrapper = {
    css: css`
        display: flex;
    `,
};

const arrowWrapper = css`
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background-color: ${getColor(colorStrings.commonGlobalWhite)};

    &:hover {
        background-color: ${getColor(colorStrings.commonGlobalGray05)};
    }
`;

customStyles.prevArrowWrapper = {
    css: css`
        ${arrowWrapper}
        left: 10px;
    `,
};

customStyles.nextArrowWrapper = {
    css: css`
        ${arrowWrapper}
        right: 10px;
    `,
};

customStyles.arrowButton = {
    css: css`
        min-height: 34px;
        height: 34px;
        width: 34px;
        background: none;
        border: 0;
        padding: 0;
        &:hover {
            background: none;
        }
        &:focus {
            outline: none;
        }

        && {
            display: inline-flex;
            align-items: center;
            justify-content: center;

            ${ButtonIcon} {
                top: 0;
                color: ${getColor(colorStrings.secondaryMain)};
            }
        }
    `,
};

customStyles.iconProps = {
    size: 26,
};

customStyles.image = {
    ...customStyles.image,
    css: css`
        ${customStyles.image?.css}
        img {
            width: auto;
            object-fit: contain;
            max-width: 100%;
        }
    `,
};
